/**
 * Lifted verbatim from legacy/prototype.html's `I` icon table and `chMark()` — same paths,
 * same visual output, just returned as React nodes instead of string concatenation.
 */
import { BUSINESS_META, type Business, type ChannelType } from '@sac/contracts'

function svg(path: string, sw = 1.7): string {
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round">${path}</svg>`
}

export const ICONS = {
  chat: svg('<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>'),
  user: svg('<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'),
  box: svg('<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7 12 12l8.7-5M12 22V12"/>'),
  check2: svg('<path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>'),
  ext: svg('<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><path d="M15 3h6v6"/><path d="M10 14 21 3"/>'),
  ticket: svg('<path d="M3 9V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z"/><path d="M13 5v2M13 11v2M13 17v2"/>'),
  chart: svg('<path d="M3 3v18h18M7 16v-5M12 16V8M17 16v-3"/>'),
  list: svg('<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>'),
  spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z"/><path d="M19 15l.9 2.4 2.4.9-2.4.9L19 21.6l-.9-2.4-2.4-.9 2.4-.9z"/></svg>',
  gear: svg('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>'),
  phone: svg('<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8.1 9.7a16 16 0 0 0 6 6l1.2-1.1a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.7.7A2 2 0 0 1 22 16.9z"/>'),
  mail: svg('<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/>'),
  pin: svg('<path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>'),
  cal: svg('<rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>'),
  bell: svg('<path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0"/>'),
  clock: svg('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
  truck: svg('<path d="M14 17V5a1 1 0 0 0-1-1H2v13h2"/><path d="M14 9h4l3 3v5h-2"/><circle cx="6.5" cy="17.5" r="2"/><circle cx="17.5" cy="17.5" r="2"/>'),
  plus: svg('<path d="M12 5v14M5 12h14"/>', 2),
  search: svg('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>', 1.9),
  dots: svg('<circle cx="5" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.4" fill="currentColor" stroke="none"/>'),
  chev: svg('<path d="m6 9 6 6 6-6"/>', 2),
  ck: svg('<path d="M20 6 9 17l-5-5"/>', 2.4),
  clip: svg('<path d="M21.4 11.05 12.25 20.2a5.5 5.5 0 0 1-7.78-7.78l9.19-9.19a3.67 3.67 0 0 1 5.19 5.19l-9.2 9.19a1.83 1.83 0 0 1-2.59-2.59l8.49-8.48"/>'),
  img: svg('<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/>'),
  smile: svg('<circle cx="12" cy="12" r="9"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/>'),
  robot: svg('<rect x="4" y="8" width="16" height="12" rx="2"/><path d="M12 8V4M9 4h6"/><path d="M9 13h.01M15 13h.01M9.5 17h5"/>'),
  bolt: svg('<path d="M13 2 3 14h8l-1 8 10-12h-8z"/>'),
  send: svg('<path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/>', 1.9),
  lock: svg('<rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>'),
  file: svg('<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>'),
  play: '<svg viewBox="0 0 24 24" fill="currentColor" style="width:12px;height:12px"><path d="M8 5v14l11-7z"/></svg>',
  link: svg('<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>'),
  warn: svg('<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>'),
  x: svg('<path d="M18 6 6 18M6 6l12 12"/>', 2),
  copy: svg('<rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>'),
} as const

export function Icon({ name, size }: { name: keyof typeof ICONS; size?: number }) {
  return (
    <span
      style={size ? { width: size, height: size, display: 'grid' } : undefined}
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  )
}

const CH_META: Record<ChannelType, { name: string; cls: string; mark: string }> = {
  whatsapp: { name: 'WhatsApp', cls: 'ch-wa', mark: 'wa' },
  whatsapp_qr: { name: 'WhatsApp (QR)', cls: 'ch-wa', mark: 'wa' },
  mercadolivre: { name: 'Mercado Livre', cls: 'ch-ml', mark: 'ML' },
  mercadolivre_question: { name: 'Mercado Livre', cls: 'ch-ml', mark: 'ML' },
  shopee: { name: 'Shopee', cls: 'ch-sh', mark: 'sh' },
  amazon: { name: 'Amazon', cls: 'ch-am', mark: 'a' },
  instagram: { name: 'Instagram', cls: 'ch-ig', mark: 'ig' },
  tiktok: { name: 'TikTok', cls: 'ch-am', mark: 'tt' },
  tiktok_comment: { name: 'TikTok', cls: 'ch-am', mark: 'tt' },
  site: { name: 'Site', cls: 'ch-site', mark: 'globe' },
  email: { name: 'Email', cls: 'ch-em', mark: 'mail' },
  internal: { name: 'Simulador', cls: 'ch-em', mark: 'mail' },
}

const MARK_SVG: Record<string, string> = {
  wa: '<svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2m0 1.8a8.2 8.2 0 1 1-4.2 15.2l-.3-.2-3 .8.8-3-.2-.3A8.2 8.2 0 0 1 12 3.8m-3.2 4c-.2 0-.5.1-.7.4-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.7 2.8 4.3 3.8 2.1.8 2.6.7 3 .6.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3l-2-1c-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.3.2-.6.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4 0-.5.2-.7l.4-.5.3-.5v-.5l-.8-2c-.2-.5-.4-.5-.6-.5z"/></svg>',
  sh: '<svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2.6c-2.2 0-4 1.8-4 4v.6H5.3c-.5 0-.9.4-1 .9L3.2 19.4c-.1 1.1.8 2 1.9 2h13.8c1.1 0 2-.9 1.9-2L19.7 8.1c-.1-.5-.5-.9-1-.9H16v-.6c0-2.2-1.8-4-4-4m0 1.8c1.2 0 2.2 1 2.2 2.2v.6H9.8v-.6c0-1.2 1-2.2 2.2-2.2m0 5.6c2 0 3.4.9 3.4 2.3 0 1.2-.9 1.9-2.5 2.3-1.3.3-1.8.6-1.8 1.1s.5.8 1.3.8c.8 0 1.4-.2 2-.6l.8 1.4c-.8.5-1.7.8-2.9.8-2 0-3.4-1-3.4-2.4 0-1.3 1-2 2.6-2.4 1.2-.3 1.7-.5 1.7-1s-.5-.8-1.3-.8c-.7 0-1.4.2-2 .6l-.8-1.4c.8-.5 1.7-.7 2.9-.7z"/></svg>',
  globe: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z"/></svg>',
  mail: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 8 9 5.5L21 8"/></svg>',
  ig: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5.5"/><circle cx="12" cy="12" r="4"/><circle cx="17.4" cy="6.6" r="1.1" fill="#fff" stroke="none"/></svg>',
}

export function ChannelMark({
  channel,
  size = 18,
  business,
}: {
  channel: ChannelType
  size?: number
  /** Draws a coloured ring identifying the legal entity. Omit or null for no ring. */
  business?: Business | null
}) {
  const meta = CH_META[channel] ?? CH_META.internal
  const svgMark = MARK_SVG[meta.mark]
  const biz = business ? BUSINESS_META[business] : null
  return (
    <span
      className={`ch ${meta.cls}${biz ? ' ch-biz' : ''}`}
      // Two facts, one glyph: which channel, and which company it trades under.
      title={biz ? `${meta.name} · ${biz.label}` : meta.name}
      style={{
        width: size,
        height: size,
        // A ring rather than a border: box-shadow sits outside the box, so the icon keeps its
        // exact size and nothing in the surrounding row shifts when a business is assigned.
        ...(biz ? ({ '--biz': biz.color } as React.CSSProperties) : {}),
      }}
    >
      {svgMark ? (
        <span
          style={{ width: Math.round(size * 0.66), height: Math.round(size * 0.66), display: 'block' }}
          dangerouslySetInnerHTML={{ __html: svgMark }}
        />
      ) : (
        <span style={{ fontSize: Math.round(size * 0.42) }}>{meta.mark}</span>
      )}
    </span>
  )
}

export function channelName(channel: ChannelType): string {
  return (CH_META[channel] ?? CH_META.internal).name
}
